var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBackgroundOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#222",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.752 10.346a.99.99 0 0 0-1.408.005 1.01 1.01 0 0 0 .006 1.42l4.236 4.236-4.248 4.248a.99.99 0 0 0 .006 1.408 1.01 1.01 0 0 0 1.42-.005L16 17.422l4.249 4.249a.99.99 0 0 0 1.409-.006 1.01 1.01 0 0 0-.006-1.42l-4.238-4.238 4.249-4.249a.99.99 0 0 0-.006-1.408 1.01 1.01 0 0 0-1.42.005L16 14.593l-4.248-4.247z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBackgroundOpacity);
export default __webpack_public_path__ + "static/media/delete_background_opacity.a24ce5b39f4fc58f2ba3d9ace59c331e.svg";
export { ForwardRef as ReactComponent };